import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableColumnsType } from 'antd';
import Button from '../../../Button';
import { IStudentTestInfo } from '../../../../models/students.model';
import { getCommonCodeLabel } from '../../../../lib/store';
import moment from 'moment';
import { getWebUrl } from '../../../../lib/util';
import Pagination from '../../../Pagination';
import config from '../../../../lib/config';

interface IProps {
  data?: IStudentTestInfo[];
}

const StudentCbtTable: FC<IProps> = ({
  data,
}) => {
  const { t, i18n } = useTranslation();
  const [page, setPage] = useState(1);

  const onOpenReportCard = (
    eduStepCode: string,
    examDiv: string,
    examTestCode: number,
  ) => {
    let examUri = '';

    if (eduStepCode === 'EM') {
      switch (examDiv) {
        case 'PT':
          examUri = 'report-card';
          break;
        case 'MT':
          examUri = 'monthly-test';
          break;
        case 'LT':
          examUri = 'level-test';
          break;
      }
    } else {
      switch (examDiv) {
        case 'PT':
          examUri = 'md-report-card';
          break;
        case 'PL':
          examUri = 'md-monthly-test';
          break;
        case 'LT':
          examUri = 'md-level-test'
      }
    }

    window.open(`${getWebUrl()}/${examUri}?examTestCode=${examTestCode}`, '_blank', 'width=1090, height=768, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=yes');
  }

  const columns: TableColumnsType<IStudentTestInfo> = [
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      key: 'eduStepCode',
      align: 'center',
      render: value => getCommonCodeLabel('PR0006', value, i18n.language),
    },
    {
      title: t('common.column.category'),
      dataIndex: 'examDiv',
      key: 'examDiv',
      align: 'center',
      render: value => getCommonCodeLabel('TE0001', value, 'ko')
    },
    {
      title: t('student.student.column117'),
      dataIndex: 'examTypeName',
      key: 'examTypeName',
      align: 'center',
    },
    {
      title: t('student.student.column118'),
      dataIndex: 'examName',
      key: 'examName',
      align: 'center',
    },
    {
      title: t('student.student.column119'),
      dataIndex: 'studentScore',
      key: 'studentScore',
      align: 'center',
    },
    {
      title: t('student.student.column115'),
      dataIndex: 'examSrtDate',
      key: 'examSrtDate',
      align: 'center',
      render: value => value ? moment(value).format('YYYY.MM.DD HH:mm:ss') : '-',
    },
    {
      title: t('student.student.column120'),
      dataIndex: 'examTestCode',
      key: 'examTestCode',
      align: 'center',
      render: (value, record) => {
        if (record.examDiv === 'PR') {
          return '-';
        } else {
          return (
            <div className="comm-btn__area justify-content-center">
              <Button
                className="btn-basic small mint"
                text={t('student.student.button23')}
                onClick={() => {
                  onOpenReportCard(record.eduStepCode, record.examDiv, value);
                }}
              />
            </div>
          );
        }
      },
    },
  ];

  return (
    <>
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={data}
        pagination={{
          current: page,
          pageSize: config.smallPageSize,
        }}
      />
      <div className="comm-bx__between">
        <div className="common-paging center">
          <Pagination count={data?.length ?? 0} page={page} setPage={setPage} perPage={config.smallPageSize} />
        </div>
      </div>
    </>
  );
};

export default StudentCbtTable;
